// src/ryan/admin/components/RyanAdminDropdown.tsx
//
// Select nativo trocado por um trigger+menu customizado — mesmo padrão
// visual/de interação já usado no seletor "Página de Divulgação"
// (RyanAdminProducts.tsx, aba Marketing: clique fora fecha via mousedown,
// fade+slide-in). Generalizado aqui (lista de {value,label,badge?} em vez de
// RyanProduct[]) pra ser reaproveitado por qualquer filtro do admin — usado
// primeiro em RyanAdminAnalytics.tsx (modo/produto/período/origem/embaixador).
import React, { useEffect, useRef, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import './RyanAdminDropdown.css';

export interface RyanAdminDropdownOption {
    value: string;
    label: string;
    badge?: string;
}

interface RyanAdminDropdownProps {
    options: RyanAdminDropdownOption[];
    value: string;
    onChange: (value: string) => void;
    icon?: React.ReactNode;
    placeholder?: string;
    emptyText?: string;
    className?: string;
}

const RyanAdminDropdown: React.FC<RyanAdminDropdownProps> = ({
    options, value, onChange, icon, placeholder = '— selecione —',
    emptyText = 'Nenhuma opção disponível.', className = '',
}) => {
    const [open, setOpen] = useState(false);
    const rootRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const handleClick = (e: MouseEvent) => {
            if (rootRef.current?.contains(e.target as Node)) return;
            setOpen(false);
        };
        if (open) document.addEventListener('mousedown', handleClick);
        return () => document.removeEventListener('mousedown', handleClick);
    }, [open]);

    const selected = options.find(o => o.value === value) || null;

    return (
        <div className={`ras-dd${className ? ` ${className}` : ''}`} ref={rootRef}>
            <button type="button" className="ras-dd-trigger" onClick={() => setOpen(v => !v)}>
                {icon && <span className="ras-dd-icon">{icon}</span>}
                <span className={`ras-dd-value${!selected ? ' ras-dd-placeholder' : ''}`}>
                    {selected ? selected.label : placeholder}
                </span>
                {selected?.badge && <span className="ras-dd-badge">{selected.badge}</span>}
                <ChevronDown size={14} className={`ras-dd-chevron${open ? ' open' : ''}`} />
            </button>
            {open && (
                <div className="ras-dd-menu">
                    {options.length === 0 ? (
                        <div className="ras-dd-empty">{emptyText}</div>
                    ) : (
                        options.map(o => (
                            <button
                                key={o.value} type="button"
                                className={`ras-dd-item${o.value === value ? ' active' : ''}`}
                                onClick={() => { onChange(o.value); setOpen(false); }}
                            >
                                <span className="ras-dd-item-label">{o.label}</span>
                                {o.badge && <span className="ras-dd-badge">{o.badge}</span>}
                            </button>
                        ))
                    )}
                </div>
            )}
        </div>
    );
};

export default RyanAdminDropdown;
